import { getFetcher } from '@glovo/fetcher';
export const API_CALL_TIMEOUT = 20000;
export const fetcher = getFetcher({
    platform: 'web',
    timeout: API_CALL_TIMEOUT,
    responseType: 'json',
});
//# sourceMappingURL=index.js.map